import { Formik } from 'formik';
import React from 'react';

import cx from '../../utils/classnames';

import type { FormikConfig, FormikProps, FormikValues } from 'formik';
type Props = FormikConfig<FormikValues> & {
  /** Custom style for wrapper */
  className?: string;

  /** use either children or render prop */
  children?: ((props: FormikProps<FormikValues>) => React.ReactNode) | React.ReactNode;
  hasValidateOnBlur?: boolean;
};

export function Form(props: Props) {
  const { className, children, hasValidateOnBlur = false, ...rest } = props;

  return (
    <div className={cx(className)}>
      <Formik validateOnBlur={hasValidateOnBlur} {...rest}>
        {children}
      </Formik>
    </div>
  );
}

export default Form;
